var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon_WARNING"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_WARNING",
    clipPath: "url(#clip-Icon_WARNING)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NOTIF._WARNING:_NORMAL",
    "data-name": "NOTIF. WARNING: NORMAL"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_9602",
    "data-name": "Rechteck 9602",
    width: 48,
    height: 48,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7617",
    "data-name": "Pfad 7617",
    d: "M24,9.13,42.563,40.254H5.572Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_37",
    "data-name": "Pfad 37",
    d: "M24,7,4,41H44Z",
    fill: "#f5802a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(22 32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_9",
    "data-name": "Rechteck 9",
    width: 2,
    height: 10,
    transform: "translate(23 19)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.6dde8d02610aa8547acd1ac283702701.svg";